export default "__VITE_ASSET__CgirA2Db__"